import React from 'react';
import { Badge, HStack, Icon } from '@chakra-ui/react';
import { FaLock } from 'react-icons/fa';

interface SMSFBadgeProps {
  show: boolean;
}

export const SMSFBadge: React.FC<SMSFBadgeProps> = ({ show }) => {
  if (!show) return null;
  return (
    <Badge
      bg="orange.100"
      color="orange.800"
      px={3}
      py={1}
      borderRadius="full"
      fontSize="xs"
      fontWeight="bold"
      letterSpacing="wider"
      textTransform="uppercase"
    >
      <HStack spacing={1} display="inline-flex" alignItems="center">
        <Icon as={FaLock} boxSize={3} />
        <span>SMSF Deal</span>
      </HStack>
    </Badge>
  );
};
